<template>
  <b-modal
    v-model="isOpen"
    header-class="header-class-modal-doc-package"
    header-bg-variant="light"
    :title="FormMSG(1, 'Info')"
    class="modal-warning"
    :modal-header-close="false"
    centered
    size="lg"
    @cancel="$emit('close')"
    @close="$emit('close')"
    @hidden="$emit('close')"
  >
    <div class="mt-2 mb-4 d-flex align-items-center justify-content-between">
      <h5>{{ FormMSG(7, 'Your last ') + ' 10 ' + FormMSG(8, ' Background tasks ') }}</h5>
      <b-button variant="link" @click="$emit('refresh')">
        <component :is="getLucideIcon('RotateCcw')" :size="16" />
        <span class="ml-2">{{ FormMSG(9, 'Refresh') }}</span>
      </b-button>
    </div>
    <b-table
      :hover="hover"
      responsive="sm"
      :items="data"
      :fields="fields"
      :current-page="currentPage"
      :per-page="0"
      bordered
      small
      sticky-header="700px"
      :head-variant="hv"
      :busy="isBusy"
      tbody-tr-class="tr-cursor"
      :empty-text="FormMSG(2, 'No jobs in progress')"
      show-empty
    >
      <template #table-busy>
        <div class="d-flex justify-content-center align-items-center">
          <b-spinner class="align-middle" small />
          <strong class="ml-2">{{ FormMSG(3, 'Loading') }}...</strong>
        </div>
      </template>
      <template #cell(taskType)="{ item }">
        <div class="d-flex align-items-center">
          <span>
            {{ FormMSG(6, 'Import Odoo electronic invoice jobs, started at:') }}
            <strong>{{ formatTzDate(item.createdAt) }}</strong>
          </span>
        </div>
      </template>
      <template #cell(status)="{ item }">
        <div class="d-flex align-items-center justify-content-center flex-row w-100" style="gap: 5px">
          <div class="d-flex align-items-center justify-content-center wrap-status">
            <div class="status" :class="getStatusColor(item.status)" style="font-size: 0.7rem">
              {{ getStatusText(item.status) }}
            </div>
          </div>
        </div>
      </template>
    </b-table>
    <template #modal-footer>
      <div class="w-100">
        <b-row class="padding-c-1">
          <b-col cols="12">
            <div class="w-90-px d-flex flex-row justify-content-center align-items-center w-100" style="gap: 20px">
              <slot name="footer-button"></slot>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </b-modal>
</template>

<script>
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import { BACKGROUND_TASK_STATUS } from '../../shared/constants';
import mapProps from '@/shared/vuePropsMapper';
import moment from 'moment';

export default {
  name: 'JobsProgressionModal',
  mixins: [globalMixin, languageMessages],
  props: {
    ...mapProps(['hover', 'striped', 'bordered'], {
      type: Boolean,
      default: true
    }),
    value: { type: Boolean, required: true },
    data: { type: Array, default: () => [], required: true },
    isBusy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: '',
      currentPage: 1,
      hv: 'dark'
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        return val;
      }
    },
    fields() {
      const fields = [
        {
          key: 'taskType',
          label: this.FormMSG(4, 'Job Details'),
          sortable: true
        },
        {
          key: 'status',
          label: this.FormMSG(5, 'Status')
        }
      ];
      return fields;
    }
  },
  methods: {
    getStatusText(validationStatus) {
      switch (validationStatus) {
        case BACKGROUND_TASK_STATUS.COMPLETED:
          return 'completed';
        case BACKGROUND_TASK_STATUS.IN_PROGRESS:
          return 'pending';
        case BACKGROUND_TASK_STATUS.FAILED:
          return 'failed';
        case BACKGROUND_TASK_STATUS.COMPLETED_WITH_ERRORS:
          return 'completed with errors';

        default:
          return 'unknown';
      }
    },
    getStatusColor(validationStatus) {
      switch (validationStatus) {
        case BACKGROUND_TASK_STATUS.COMPLETED:
          return 'validated';
        case BACKGROUND_TASK_STATUS.IN_PROGRESS:
          return 'pending';
        case BACKGROUND_TASK_STATUS.FAILED:
          return 'refused';
        case BACKGROUND_TASK_STATUS.COMPLETED_WITH_ERRORS:
          return 'refused';

        default:
          return 'info';
      }
    },
    formatTzDate(date) {
      return moment(date).format('DD/MM/yyyy HH:mm:ss');
    }
  }
};
</script>

<style lang="scss" scoped></style>
